import { render, staticRenderFns } from "./ace-editor.vue?vue&type=template&id=2fa60dd4&"
import script from "./ace-editor.vue?vue&type=script&lang=js&"
export * from "./ace-editor.vue?vue&type=script&lang=js&"
import style0 from "./ace-editor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ace-editor.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports